const captureTrafficSource = (to) => {
  if (typeof window === 'undefined' || !window.localStorage) return;

  const utmSource = to.query?.['utm_source'] ?? null;
  const utmMedium = to.query?.['utm_medium'] ?? null;
  const utmCampaign = to.query?.['utm_campaign'] ?? null;
  
  if (!utmSource && !utmMedium && !utmCampaign) return;

  let existingAttribution = {};
  // Need to catch errors when parsing JSON string
  try {
    const stored = localStorage.getItem('utm_traffic_source');
    if (stored) existingAttribution = JSON.parse(stored);
  } catch (e) {
    //
  }

  const attribution = {
    source: utmSource || existingAttribution.source || '',
    medium: utmMedium || existingAttribution.medium || '',
    campaign: utmCampaign || existingAttribution.campaign || '',
  };

  localStorage.setItem('utm_traffic_source', JSON.stringify(attribution));
}

const retrieveTrafficSource = () => {
  if (typeof window === 'undefined' || !window.localStorage) return url;

    const result = {
        utmSource: null,
        medium: null,
        campaign: null,
    }

  try {
    const stored = localStorage.getItem('utm_traffic_source');
    if (!stored) return result;

    const attribution = JSON.parse(stored);
    if (!attribution) return result;

    if (attribution?.source) result.utmSource = attribution.source;
    if (attribution?.medium) result.medium = attribution.medium;
    if (attribution?.campaign) result.campaign = attribution.campaign;

    return result;
  } catch (e) {
    return result;
  }
}

export {
    captureTrafficSource,
    retrieveTrafficSource,
}

